"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const GuidesButton_1 = __importDefault(require("../../../atoms/GuidesButton"));
const SketchOptions_1 = __importDefault(require("../../../molecules/SketchOptions"));
const ToolsMode_1 = __importDefault(require("../../../templates/ToolsMode"));
const hooks_1 = require("../../../hooks");
const providers_1 = require("../../../providers");
const ui_1 = require("@completeanatomy/ui");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const animation_1 = require("../../../utils/animation");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const useSketchOptions_1 = require("../../../hooks/useSketchOptions");
function ToolSketchModePage() {
    var _a;
    const [isUIHidden, toggleUIHidden] = (0, ui_1.useToggleState)(false);
    const [isOptionsActive, setOptionsActive] = (0, react_1.useState)(false);
    const [{ isGuidesAvailable, isGuidesExpanded }] = (0, providers_1.useGuidesContext)();
    const [selectedID, setSelectedID] = (0, react_1.useState)('');
    const { color, size } = (0, useSketchOptions_1.useSketchOptions)();
    const [selectedColor, setSelectedColor] = (0, react_1.useState)(color);
    const [selectedSize, setSelectedSize] = (0, react_1.useState)(size);
    const tools = (0, providers_1.useToolsService)();
    const stickiesToolManager = (_a = tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager()) !== null && _a !== void 0 ? _a : null;
    const stickies = (0, hooks_1.useStickiesState)();
    const sketches = stickies.filter(s => s.type === bridge_schema_1.ToolType.StickyHandWriting);
    const bridge = (0, bridge_1.useBridge)();
    (0, react_1.useEffect)(() => {
        bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
            type: bridge_schema_1.ToolType.StickyHandWriting,
            currentOptions: { type: bridge_schema_1.ToolType.StickyHandWriting },
        });
    }, [bridge]);
    const onClear = () => {
        stickiesToolManager === null || stickiesToolManager === void 0 ? void 0 : stickiesToolManager.clearStickiesByType(bridge_schema_1.ToolType.StickyHandWriting);
    };
    const onToggle = (isActive) => {
        setOptionsActive(isActive);
    };
    const isGuidesButtonVisible = isGuidesAvailable && !isGuidesExpanded && !isUIHidden;
    return ((0, jsx_runtime_1.jsxs)(ToolsMode_1.default, { title: isOptionsActive
            ? (0, i18n_1.Localized)(i18n_1.Strings.tools.sketch.titleOptions)
            : (0, i18n_1.Localized)(i18n_1.Strings.tools.sketch.title), clearTitle: (0, i18n_1.Localized)(i18n_1.Strings.tools.sketch.clear), onToggleUI: toggleUIHidden, onClear: onClear, selectedType: bridge_schema_1.ToolType.StickyHandWriting, setSelectedID: setSelectedID, selectedColor: selectedColor, selectedSize: selectedSize, isClearActive: (sketches === null || sketches === void 0 ? void 0 : sketches.length) > 0, "data-e2e": 'ToolSketchModePage_ToolsModeTemplate', children: [(0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: !isUIHidden, timeout: 300, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'ToolSketchModePage_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledToolsSketchOptionsPanel, { onToggle: onToggle, color: selectedColor, size: selectedSize, selectedID: selectedID, setSelectedColor: setSelectedColor, setSelectedSize: setSelectedSize, "data-e2e": 'ToolSketchModePage_StyledToolsSketchOptionsPanel' }) }), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isGuidesButtonVisible, timeout: 300, mountOnEnter: true, unmountOnExit: true, appear: true, "data-e2e": 'ToolSketchModePage_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledGuidesButton, { "data-e2e": 'ToolSketchModePage_StyledGuidesButton' }) })] }));
}
exports.default = ToolSketchModePage;
const StyledToolsSketchOptionsPanel = (0, styled_components_1.default)(SketchOptions_1.default) `
  position: absolute;
  bottom: 20px;
  left: calc(50% - 50px);

  z-index: 2;

  ${(0, animation_1.SlideDown)('130%')}
`;
const StyledGuidesButton = (0, styled_components_1.default)(GuidesButton_1.default) `
  position: absolute;
  bottom: 20px;
  left: 15px;

  ${(0, animation_1.SlideDown)('130%')}
`;
